export function isTextNode(node) {
    return node.nodeType === Node.TEXT_NODE;
}
export function isCommentNode(node) {
    return node.nodeType === Node.COMMENT_NODE;
}
export function isElementNode(node) {
    return node.nodeType === Node.ELEMENT_NODE;
}
export function isNodeShadowHost(node) {
    return isElementNode(node) && Boolean(node.shadowRoot);
}
export function isNodeShadowRoot(node) {
    const shadowRoot = node;
    return !!shadowRoot.host && shadowRoot.nodeType === Node.DOCUMENT_FRAGMENT_NODE && isElementNode(shadowRoot.host);
}
export function hasChildNodes(node) {
    return node.childNodes.length > 0 || isNodeShadowHost(node);
}
export function forEachChildNodes(node, callback) {
    let child = node.firstChild;
    while (child) {
        callback(child);
        child = child.nextSibling;
    }
    if (isNodeShadowHost(node)) {
        callback(node.shadowRoot);
    }
}
/**
 * Return `host` in case if the current node is a shadow root otherwise will return the `parentNode`
 */
export function getParentNode(node) {
    return isNodeShadowRoot(node) ? node.host : node.parentNode;
}
/**
 * Return the parent element, crossing shadow DOM boundaries.
 * If the element is a direct child of a shadow root, returns the shadow host.
 */
export function getParentElement(element) {
    if (element.parentElement) {
        return element.parentElement;
    }
    const parentNode = element.parentNode;
    if (parentNode && isNodeShadowRoot(parentNode)) {
        return parentNode.host;
    }
    return null;
}
//# sourceMappingURL=htmlDomUtils.js.map